// for_dev_oita
// export const URL_BASE_DOMAIN='d3llxngaz2p8dg.cloudfront.net'
// export const USER_POOL_ID='ap-northeast-1_cKwRDlxq4'
// export const CLI_ID='k1kctfm633bc7f1pftdnau8gj'
// export const PMTILES_PREF_KEY='oita'
// export const DEFAULT_POSITION = [131.6068285, 33.2305526]
// export const FOR_COLOR_TEST = true // 色付き環境でテストする場合はtrueにする

// for_prod_oita
// export const URL_BASE_DOMAIN='dsbd.cerd-edison.com'
// export const USER_POOL_ID='ap-northeast-1_xSwUTbfz6'
// export const CLI_ID='22d18lu50dppsjctpgq6jh1td9'
// export const PMTILES_PREF_KEY='oita'
// export const DEFAULT_POSITION = [131.6068285, 33.2305526]
// export const FOR_COLOR_TEST = false // 色付き環境でテストする場合はtrueにする

// for_test_oita
export const URL_BASE_DOMAIN='demo.dsbd.cerd-edison.com'
export const USER_POOL_ID='ap-northeast-1_nIBWoiMcS'
export const CLI_ID='7iae2tsm41ugf2rvh77eav7d9d'
export const PMTILES_PREF_KEY='oita'
export const DEFAULT_POSITION = [131.6068285, 33.2305526]
export const FOR_COLOR_TEST = true // 色付き環境でテストする場合はtrueにする